import { createFileRoute, redirect } from '@tanstack/react-router';

// Cuando el usuario entra a /:wsSlug sin sufijo (WorkspaceSwitcher, link viejo,
// URL pegada a mano), redirigir a la pantalla de proyectos del workspace.
export const Route = createFileRoute('/_app/$wsSlug/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$wsSlug/projects',
      params: { wsSlug: params.wsSlug },
      replace: true,
    });
  },
});
